import { COMING_SOON_IMAGE } from 'Components/ImagePlaceholder'
import { appendImageTimestamp } from './listingUtils'


export const REPLIERS_PHOTO_SOURCE = 'REPLIERS'

export const createPhotoPaths = ({
  photoBaseUrl, mlsNumber, photoIndex, photoVersion, photoSource,
}) => {
  const isRepliers = photoSource === REPLIERS_PHOTO_SOURCE

  const originImg = !isRepliers ?
    `${photoBaseUrl}${mlsNumber.toLowerCase()}_${photoIndex}` :
    `${photoBaseUrl}${mlsNumber}_${photoIndex}`

  if(!isRepliers) {
    return {
      img: appendImageTimestamp(`${originImg}-640x480.jpg`, photoVersion),
      imgSmall: appendImageTimestamp(`${originImg}-320x240.jpg`, photoVersion),
      lowQualityImgPath: appendImageTimestamp(`${originImg}-110x73.jpg`, photoVersion),
      originImg: appendImageTimestamp(`${originImg}.jpg`, photoVersion),
    }
  }

  // look into updating images from repliers if listing image gets updated
  return {
    img: `${originImg}.jpg?width=640&v=${photoVersion}`,
    imgSmall: `${originImg}.jpg?width=320&v=${photoVersion}`,
    lowQualityImgPath: `${originImg}.jpg?width=110&v=${photoVersion}`,
    originImg: `${originImg}.jpg?v=${photoVersion}`,
  }
}

export const createListingPhotoUrlList = (listing) => {
  const urlList = []

  const {
    photo_count: photoCount,
    photo_base_url: photoBaseUrl,
    mls_number: mlsNumber,
    photo_list: photoList,
    photo_version: photoVersion,
    photo_source: photoSource,
  } = listing || {}

  if(photoCount && photoBaseUrl && mlsNumber) {
    for(let photoIndex = 1; photoIndex <= photoCount; photoIndex += 1) {
      const photo = createPhotoPaths({
        photoBaseUrl,
        mlsNumber,
        photoIndex,
        photoVersion,
        photoSource,
      })

      urlList.push(photo)
    }
  } else if(photoList) {
    photoList.forEach(photoUrl => {
      const urlWithParam = appendImageTimestamp(photoUrl)
      urlList.push({
        img: urlWithParam,
        originImg: urlWithParam,
      })
    })
  }
  if(urlList.length < 1) {
    urlList.push({
      img: COMING_SOON_IMAGE,
    })
  }
  return urlList
}
